import React, { useEffect } from 'react';
import { actionCreators } from './action';
import { connect } from 'react-redux';
import Tasks from '../Tasks';
import Spinner from '../Spinner';
 function TasksList(props) {

    useEffect(() => {
        props.fetchTasks();
      });
  return (
  <div>
    <Spinner >
      <Tasks {...props} />
    </Spinner>
  </div>);
}


export default connect(
  null,
  actionCreators
)(TasksList)